import {useIntl, FormatNumberOptions} from 'react-intl'

/**
 * A simplified hook for using i18n in the application
 * @returns Object containing utility functions for working with i18n
 */
export const useI18n = () => {
  const intl = useIntl()

  return {
    /**
     * Translate an i18n string
     * @param id i18n key
     * @param values Values to replace in the string (if any)
     * @returns Translated string
     */
    t: (id: string, values?: Record<string, string | number>) => intl.formatMessage({id}, values),

    /**
     * Format date according to current language
     * @param date Date object
     * @param options Format options
     * @returns Formatted date string
     */
    formatDate: (date: Date, options?: Intl.DateTimeFormatOptions) =>
      intl.formatDate(date, options),

    /**
     * Format number according to current language
     * @param value Number to format
     * @param options Format options
     * @returns Formatted number string
     */
    formatNumber: (value: number, options?: FormatNumberOptions) =>
      intl.formatNumber(value, options),
  }
}
